var _path, _g, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 813,
    height: 928,
    viewBox: "0 0 813 928",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M812.234 84.6522C812.234 84.6522 558.41 164.014 406.312 0C254.258 164.014 0.390458 84.6522 0.390458 84.6522C0.390458 84.6522 -3.03298 102.703 10.394 132.136C10.394 132.136 31.2459 577.538 51.6531 639.649C100.07 786.901 201.351 812.777 406.312 927.84C611.273 812.777 712.598 786.901 760.971 639.649C781.378 577.538 802.23 132.136 802.23 132.136C815.701 102.703 812.234 84.6522 812.234 84.6522ZM707.619 636.803C640.795 756.801 561.478 773.118 406.668 850.968C251.902 773.118 172.629 756.801 105.806 636.803C58.2777 551.395 51.1196 141.25 51.1196 141.25C80.1076 145.429 107.406 147.252 133.015 147.252C312.056 147.252 406.668 57.7983 406.668 57.7983C406.668 57.7983 530.356 174.64 762.305 141.25C762.305 141.25 755.147 551.395 707.619 636.803Z",
    fill: "url(#paint0_linear_6_37)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406.312 850.79V886.981C406.312 886.981 363.364 856.97 264.617 807.886C174.897 763.248 77.1733 705.628 80.5078 544.504C87.3102 585.363 95.6243 618.53 105.806 636.803C172.585 756.712 251.768 773.074 406.312 850.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.161 548.861C733.672 706.65 636.927 763.648 548.051 807.886C449.261 856.97 406.312 886.981 406.312 886.981V850.79C406.445 850.835 406.534 850.924 406.668 850.968C561.478 773.118 640.795 756.801 707.619 636.803C717.4 619.153 725.492 587.719 732.161 548.861Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.823 551.351C464.263 551.351 511.638 503.976 511.638 445.536C511.638 387.095 464.263 339.72 405.823 339.72C347.383 339.72 300.008 387.095 300.008 445.536C300.008 503.976 347.383 551.351 405.823 551.351Z",
    fill: "url(#paint1_linear_6_37)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M370.255 402.854V488.04C370.255 495.776 378.613 500.577 385.282 496.754L458.153 454.872C465.4 450.693 465.4 440.2 458.153 436.021L385.282 394.14C378.613 390.316 370.255 395.118 370.255 402.854Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M399.11 710.429V764.004C355.45 741.996 210.376 676.684 176.186 585.541C136.572 479.903 131.37 275.787 130.703 217.277C141.329 236.973 158.313 263.56 180.499 281.833C183.922 365.774 193.615 495.198 221.18 568.69C244.433 630.712 349.27 685.665 399.11 710.429Z",
    fill: "url(#paint2_linear_6_37)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M621.989 585.541C587.843 676.684 442.77 741.996 399.11 764.004V710.429C448.949 685.665 553.787 630.712 577.039 568.69C609.718 481.504 617.276 315.979 619.054 240.574L406.534 198.515H406.446V149.564L667.56 201.227C667.56 201.227 668.583 461.363 621.989 585.541Z",
    fill: "url(#paint3_linear_6_37)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M391.729 198.515L179.165 240.574C179.432 252.356 179.876 266.317 180.499 281.833C158.313 263.56 141.329 236.973 130.703 217.277C130.614 207.007 130.614 201.227 130.614 201.227L391.729 149.564V198.515Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_37",
    x1: 406.322,
    y1: -155.899,
    x2: 406.322,
    y2: 928.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9683,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_37",
    x1: 405.804,
    y1: 296.062,
    x2: 405.804,
    y2: 601.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2968,
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8486,
    stopColor: "#C0151B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_37",
    x1: 184.174,
    y1: 443.909,
    x2: 360.811,
    y2: 646.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D71920"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1221B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_37",
    x1: 652.557,
    y1: 224.159,
    x2: 319.337,
    y2: 589.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73D5EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E3191"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e69a83289f099720c58f0153f8184f6c.svg";
export { ForwardRef as ReactComponent };